// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `iframe#webpack-dev-server-client-overlay {
  display: none;
}

/* =============================================
   Base & typography
   ============================================= */
body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--colour_off_white_background) !important;
  line-height: 1.65;
  color: #222;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

/* =============================================
   Section headers
   Use --colour_menu_main (brand) not --colour_heading_success (price/lime green).
   Success green is for prices, badges, and confirmation states only.
   ============================================= */
.sectionHeader {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif !important;
  font-size: 26px !important;
  color: var(--colour_menu_main) !important;
  font-weight: 800 !important;
  letter-spacing: -0.02em !important;
}

.eventHeader {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif !important;
  font-size: 20px !important;
  color: var(--colour_menu_main) !important;
  font-weight: 700 !important;
}

/* =============================================
   Layout
   ============================================= */
.contentContainer {
  padding-top: 2.5rem !important;
  padding-bottom: 3.5rem !important;
}

/* =============================================
   Fixed header / nav
   ============================================= */
.ui.menu.fixed {
  min-height: 58px !important;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.18) !important;
}

.ui.menu.fixed .item {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  font-size: 0.875rem !important;
  font-weight: 500;
  letter-spacing: 0.01em;
  transition: background 0.15s ease !important;
}

.ui.menu.fixed .item:hover {
  background: rgba(255, 255, 255, 0.1) !important;
}

.ui.menu.fixed .ui.container {
  min-height: 58px !important;
}

.headerImage {
  width: 120px !important;
  max-height: 36px !important;
  object-fit: contain !important;
  margin: 4px 4px 6px;
}

/* =============================================
   Cards — default depth (not just on hover)
   ============================================= */
.ui.card,
.ui.cards > .card {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.07), 0 4px 18px rgba(0, 0, 0, 0.08) !important;
  border: 1px solid rgba(0, 0, 0, 0.05) !important;
  border-radius: 12px !important;
}

.eventCard {
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease !important;
}

.eventCard:hover {
  transform: translateY(-4px) !important;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.14) !important;
}

/* =============================================
   Segments — consistent subtle shadow
   ============================================= */
.ui.segment:not(.basic) {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 4px 16px rgba(0, 0, 0, 0.06) !important;
  border: 1px solid rgba(0, 0, 0, 0.05) !important;
  border-radius: 12px !important;
}

.ui.raised.segment {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08), 0 12px 36px rgba(0, 0, 0, 0.1) !important;
}

/* =============================================
   Ticket cards
   Brand-color left accent (was 6px lime-green — jarring)
   ============================================= */
.ticketCard {
  border-left: 3px solid var(--colour_menu_main) !important;
  border-radius: 10px !important;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.07), 0 4px 18px rgba(0, 0, 0, 0.08) !important;
}

.ticketCode {
  font-family: monospace;
  font-size: 0.82rem;
  color: #666;
  word-break: break-all;
}

/* =============================================
   Labels — consistent radius
   ============================================= */
.ui.label {
  border-radius: 6px !important;
  font-weight: 600 !important;
}

/* =============================================
   Buttons — smooth & springy
   ============================================= */
.ui.button {
  border-radius: 8px !important;
  letter-spacing: 0.01em;
  transition: filter 0.15s ease, transform 0.1s ease, box-shadow 0.15s ease !important;
}

.ui.button:not(:disabled):not(.disabled):hover {
  filter: brightness(1.06);
}

.ui.button:not(:disabled):not(.disabled):active {
  transform: translateY(1px) !important;
  filter: brightness(0.97);
}

/* =============================================
   Inputs & forms
   ============================================= */
.ui.input > input {
  border-radius: 8px !important;
  transition: border-color 0.15s ease, box-shadow 0.15s ease !important;
}

.ui.input > input:focus {
  border-color: var(--colour_menu_main) !important;
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.07) !important;
}

.ui.form input:focus,
.ui.form textarea:focus {
  border-color: var(--colour_menu_main) !important;
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.07) !important;
}

/* =============================================
   Auth pages
   ============================================= */
.authCard {
  background-color: #fff;
  border-radius: 16px !important;
  padding: 52px;
  position: relative;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1) !important;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.authHeader {
  font-size: 22px !important;
  color: var(--colour_menu_main) !important;
  font-weight: 700 !important;
  letter-spacing: -0.01em !important;
  margin-bottom: 1.5rem !important;
}

.buttonx {
  background-color: var(--colour_menu_main) !important;
  color: #fff !important;
  border-radius: 8px !important;
}

.buttonx:hover {
  filter: brightness(1.06);
  background-color: var(--colour_menu_main) !important;
}

.options {
  font-size: 0.875rem;
  color: #666;
}

.options a {
  color: var(--colour_link);
  text-decoration: none;
  margin-left: 4px;
}

/* =============================================
   Links
   ============================================= */
a {
  transition: opacity 0.12s ease;
}

/* =============================================
   Semantic UI overrides — tighten up defaults
   ============================================= */

/* Remove Semantic UI's default flat border on cards */
.ui.card > .content,
.ui.cards > .card > .content {
  border-top: 1px solid rgba(0, 0, 0, 0.04) !important;
}

/* Slightly tighter message boxes */
.ui.message {
  border-radius: 10px !important;
  box-shadow: none !important;
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
}

/* Select dropdowns */
.ui.selection.dropdown {
  border-radius: 8px !important;
  transition: border-color 0.15s ease !important;
}

.ui.selection.dropdown:focus,
.ui.selection.active.dropdown {
  border-color: var(--colour_menu_main) !important;
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.06) !important;
}

/* Confirm modal */
.ui.modal {
  border-radius: 14px !important;
  overflow: hidden;
}

/* =============================================
   Mobile
   ============================================= */
@media only screen and (max-width: 767px) {
  html, body {
    overflow-x: hidden !important;
  }

  .contentContainer {
    padding-top: 1.5rem !important;
    padding-bottom: 2.5rem !important;
    padding-left: 1rem !important;
    padding-right: 1rem !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    width: 100% !important;
  }

  .contentContainer > .ui.grid {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .sectionHeader {
    font-size: 22px !important;
  }

  .authCard {
    padding: 36px 24px !important;
    border-radius: 12px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;;kDAEkD;AAClD;EACE,SAAS;EACT;kFACgF;EAChF,mCAAmC;EACnC,kCAAkC;EAClC,+DAA+D;EAC/D,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,+EAA+E;AACjF;;AAEA;;;;kDAIkD;AAClD;EACE;2EACyE;EACzE,0BAA0B;EAC1B,yCAAyC;EACzC,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE;2EACyE;EACzE,0BAA0B;EAC1B,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;;kDAEkD;AAClD;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;;kDAEkD;AAClD;EACE,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,8BAA8B;EAC9B,gBAAgB;EAChB,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;kDAEkD;AAClD;;EAEE,oFAAoF;EACpF,gDAAgD;EAChD,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,kEAAkE;AACpE;;AAEA;EACE,sCAAsC;EACtC,qDAAqD;AACvD;;AAEA;;kDAEkD;AAClD;EACE,oFAAoF;EACpF,gDAAgD;EAChD,8BAA8B;AAChC;;AAEA;EACE,oFAAoF;AACtF;;AAEA;;;kDAGkD;AAClD;EACE,yDAAyD;EACzD,8BAA8B;EAC9B,oFAAoF;AACtF;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,qBAAqB;AACvB;;AAEA;;kDAEkD;AAClD;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;;kDAEkD;AAClD;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,oFAAoF;AACtF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,wBAAwB;AAC1B;;AAEA;;kDAEkD;AAClD;EACE,6BAA6B;EAC7B,qEAAqE;AACvE;;AAEA;EACE,gDAAgD;EAChD,oDAAoD;AACtD;;AAEA;;EAEE,gDAAgD;EAChD,oDAAoD;AACtD;;AAEA;;kDAEkD;AAClD;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,oDAAoD;EACpD,qCAAqC;AACvC;;AAEA;EACE,0BAA0B;EAC1B,yCAAyC;EACzC,2BAA2B;EAC3B,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,oDAAoD;EACpD,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,oDAAoD;AACtD;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;kDAEkD;AAClD;EACE,8BAA8B;AAChC;;AAEA;;kDAEkD;;AAElD,sDAAsD;AACtD;;EAEE,oDAAoD;AACtD;;AAEA,mCAAmC;AACnC;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA,qBAAqB;AACrB;EACE,6BAA6B;EAC7B,8CAA8C;AAChD;;AAEA;;EAEE,gDAAgD;EAChD,oDAAoD;AACtD;;AAEA,kBAAkB;AAClB;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;;kDAEkD;AAClD;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,8BAA8B;IAC9B,iCAAiC;IACjC,6BAA6B;IAC7B,8BAA8B;IAC9B,yBAAyB;IACzB,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;IACzB,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;IAC7B,8BAA8B;EAChC;AACF","sourcesContent":["iframe#webpack-dev-server-client-overlay {\n  display: none;\n}\n\n/* =============================================\n   Base & typography\n   ============================================= */\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--colour_off_white_background) !important;\n  line-height: 1.65;\n  color: #222;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n/* =============================================\n   Section headers\n   Use --colour_menu_main (brand) not --colour_heading_success (price/lime green).\n   Success green is for prices, badges, and confirmation states only.\n   ============================================= */\n.sectionHeader {\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,\n    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif !important;\n  font-size: 26px !important;\n  color: var(--colour_menu_main) !important;\n  font-weight: 800 !important;\n  letter-spacing: -0.02em !important;\n}\n\n.eventHeader {\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,\n    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif !important;\n  font-size: 20px !important;\n  color: var(--colour_menu_main) !important;\n  font-weight: 700 !important;\n}\n\n/* =============================================\n   Layout\n   ============================================= */\n.contentContainer {\n  padding-top: 2.5rem !important;\n  padding-bottom: 3.5rem !important;\n}\n\n/* =============================================\n   Fixed header / nav\n   ============================================= */\n.ui.menu.fixed {\n  min-height: 58px !important;\n  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.18) !important;\n}\n\n.ui.menu.fixed .item {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n  font-size: 0.875rem !important;\n  font-weight: 500;\n  letter-spacing: 0.01em;\n  transition: background 0.15s ease !important;\n}\n\n.ui.menu.fixed .item:hover {\n  background: rgba(255, 255, 255, 0.1) !important;\n}\n\n.ui.menu.fixed .ui.container {\n  min-height: 58px !important;\n}\n\n.headerImage {\n  width: 120px !important;\n  max-height: 36px !important;\n  object-fit: contain !important;\n  margin: 4px 4px 6px;\n}\n\n/* =============================================\n   Cards — default depth (not just on hover)\n   ============================================= */\n.ui.card,\n.ui.cards > .card {\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.07), 0 4px 18px rgba(0, 0, 0, 0.08) !important;\n  border: 1px solid rgba(0, 0, 0, 0.05) !important;\n  border-radius: 12px !important;\n}\n\n.eventCard {\n  cursor: pointer;\n  transition: transform 0.18s ease, box-shadow 0.18s ease !important;\n}\n\n.eventCard:hover {\n  transform: translateY(-4px) !important;\n  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.14) !important;\n}\n\n/* =============================================\n   Segments — consistent subtle shadow\n   ============================================= */\n.ui.segment:not(.basic) {\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 4px 16px rgba(0, 0, 0, 0.06) !important;\n  border: 1px solid rgba(0, 0, 0, 0.05) !important;\n  border-radius: 12px !important;\n}\n\n.ui.raised.segment {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08), 0 12px 36px rgba(0, 0, 0, 0.1) !important;\n}\n\n/* =============================================\n   Ticket cards\n   Brand-color left accent (was 6px lime-green — jarring)\n   ============================================= */\n.ticketCard {\n  border-left: 3px solid var(--colour_menu_main) !important;\n  border-radius: 10px !important;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.07), 0 4px 18px rgba(0, 0, 0, 0.08) !important;\n}\n\n.ticketCode {\n  font-family: monospace;\n  font-size: 0.82rem;\n  color: #666;\n  word-break: break-all;\n}\n\n/* =============================================\n   Labels — consistent radius\n   ============================================= */\n.ui.label {\n  border-radius: 6px !important;\n  font-weight: 600 !important;\n}\n\n/* =============================================\n   Buttons — smooth & springy\n   ============================================= */\n.ui.button {\n  border-radius: 8px !important;\n  letter-spacing: 0.01em;\n  transition: filter 0.15s ease, transform 0.1s ease, box-shadow 0.15s ease !important;\n}\n\n.ui.button:not(:disabled):not(.disabled):hover {\n  filter: brightness(1.06);\n}\n\n.ui.button:not(:disabled):not(.disabled):active {\n  transform: translateY(1px) !important;\n  filter: brightness(0.97);\n}\n\n/* =============================================\n   Inputs & forms\n   ============================================= */\n.ui.input > input {\n  border-radius: 8px !important;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease !important;\n}\n\n.ui.input > input:focus {\n  border-color: var(--colour_menu_main) !important;\n  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.07) !important;\n}\n\n.ui.form input:focus,\n.ui.form textarea:focus {\n  border-color: var(--colour_menu_main) !important;\n  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.07) !important;\n}\n\n/* =============================================\n   Auth pages\n   ============================================= */\n.authCard {\n  background-color: #fff;\n  border-radius: 16px !important;\n  padding: 52px;\n  position: relative;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1) !important;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.authHeader {\n  font-size: 22px !important;\n  color: var(--colour_menu_main) !important;\n  font-weight: 700 !important;\n  letter-spacing: -0.01em !important;\n  margin-bottom: 1.5rem !important;\n}\n\n.buttonx {\n  background-color: var(--colour_menu_main) !important;\n  color: #fff !important;\n  border-radius: 8px !important;\n}\n\n.buttonx:hover {\n  filter: brightness(1.06);\n  background-color: var(--colour_menu_main) !important;\n}\n\n.options {\n  font-size: 0.875rem;\n  color: #666;\n}\n\n.options a {\n  color: var(--colour_link);\n  text-decoration: none;\n  margin-left: 4px;\n}\n\n/* =============================================\n   Links\n   ============================================= */\na {\n  transition: opacity 0.12s ease;\n}\n\n/* =============================================\n   Semantic UI overrides — tighten up defaults\n   ============================================= */\n\n/* Remove Semantic UI's default flat border on cards */\n.ui.card > .content,\n.ui.cards > .card > .content {\n  border-top: 1px solid rgba(0, 0, 0, 0.04) !important;\n}\n\n/* Slightly tighter message boxes */\n.ui.message {\n  border-radius: 10px !important;\n  box-shadow: none !important;\n  border: 1px solid rgba(0, 0, 0, 0.08) !important;\n}\n\n/* Select dropdowns */\n.ui.selection.dropdown {\n  border-radius: 8px !important;\n  transition: border-color 0.15s ease !important;\n}\n\n.ui.selection.dropdown:focus,\n.ui.selection.active.dropdown {\n  border-color: var(--colour_menu_main) !important;\n  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.06) !important;\n}\n\n/* Confirm modal */\n.ui.modal {\n  border-radius: 14px !important;\n  overflow: hidden;\n}\n\n/* =============================================\n   Mobile\n   ============================================= */\n@media only screen and (max-width: 767px) {\n  html, body {\n    overflow-x: hidden !important;\n  }\n\n  .contentContainer {\n    padding-top: 1.5rem !important;\n    padding-bottom: 2.5rem !important;\n    padding-left: 1rem !important;\n    padding-right: 1rem !important;\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n    width: 100% !important;\n  }\n\n  .contentContainer > .ui.grid {\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n  }\n\n  .sectionHeader {\n    font-size: 22px !important;\n  }\n\n  .authCard {\n    padding: 36px 24px !important;\n    border-radius: 12px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
